module.exports = __webpack_public_path__ + "cd68e9a378fe8dcb00e9ba35326cb175.pdf";